import { pathOr } from 'ramda';

import { IState } from '../../store';

export const getNewbuildingRating = (state: IState) => {
  return pathOr('', ['offerData', 'newbuildingRating'], state);
};
